<div
	class="flex h-full min-h-0 flex-col"
	id="wrapper"
>
	<div
		*ngIf="calendarView$ | async as vm"
		class="mx-6 mb-4 flex min-h-0 flex-1 flex-col"
	>
		<div
			[style.grid-template-columns]="'auto 1fr auto'"
			[style.grid-template-rows]="gridTemplateRows(vm)"
			#calendarGrid
			class="grid min-h-0 flex-1"
		>
			<div class="calendar-grid-col col-start-1 row-start-1 min-h-0 overflow-y-hidden">
				<div class="row-start-1 flex h-[56px] shrink-0 items-center px-2">
					<ng-container *ngTemplateOutlet="toolbar"></ng-container>
				</div>
				@for (day of vm.days; track day.dayKey; let i = $index) {
				<div
					[style.grid-row]="i + 2"
					#dayRowMeasure
					class="min-h-0 overflow-hidden"
				>
					<app-calendar-day-sidebar
						(createAbsence)="createNewAbsenceTime(day.date)"
						(createProject)="createNewProjecthourTime(day.date)"
						(createWorking)="createNewWorkinghourTime(day.date)"
						(projectRowToggle)="onProjectRowToggle(day)"
						[day]="day"
						[enabledTimes]="vm.enabledTimes"
					/>
				</div>
				}
			</div>
			<div
				#timelineScroll
				class="calendar-grid-col col-start-2 row-start-1 grid min-h-0 min-w-0 overflow-x-auto overflow-y-hidden"
			>
				<div
					[style.minWidth.px]="vm.timelineWidthPx"
					class="calendar-grid-timeline-inner relative min-h-0"
				>
					<tg-current-time-indicator
						[dayEndHour]="vm.dayEndHour"
						[dayHeightPx]="measuredDayRowHeightPx || vm.dayRowHeightPx"
						[dayStartHour]="vm.dayStartHour"
						[segmentWidthPx]="vm.segmentWidthPx"
						[timelineWidthPx]="vm.timelineWidthPx"
						[todayIndex]="vm.todayIndex"
					/>
					<div class="row-start-1 shrink-0">
						<app-calendar-timeline-header
							[enabledTimes]="vm.enabledTimes"
							[vm]="vm"
						/>
					</div>
					@for (day of vm.days; track day.dayKey; let i = $index) {
					<div
						[style.grid-row]="i + 2"
						class="min-h-0"
					>
						<app-calendar-timer-day-segments
							(projectFillClick)="onProjectFillClick(day, $event)"
							(projectFillContextDuplicate)="onProjectFillContextDuplicate($event)"
							(projectFillContextEdit)="onProjectFillContextEdit($event)"
							(projectFillContextRemove)="onProjectFillContextRemove($event)"
							(projectPointerDown)="onProjectPointerDown(day, $event)"
							(projectPointerMove)="onProjectPointerMove(day, $event)"
							(workingFillClick)="onWorkingFillClick(day, $event)"
							(workingPointerDown)="onWorkingPointerDown(day, $event)"
							(workingPointerMove)="onWorkingPointerMove(day, $event)"
							[day]="day"
							[dayStartHour]="vm.dayStartHour"
							[draggingProjectColor]="draggingTimeEntryProjectColor"
							[draggingWorkingStyle]="draggingComegoSelectionStyle"
							[enabledTimes]="vm.enabledTimes"
							[hourLabelOffsetPx]="vm.hourLabelOffsetPx"
							[projectSelection]="projectSelectionFor(day.dayKey)"
							[segmentsPerHour]="vm.segmentsPerHour"
							[segmentWidthPx]="vm.segmentWidthPx"
							[timelineWidthPx]="vm.timelineWidthPx"
							[workingSelection]="workingSelectionFor(day.dayKey)"
						/>
					</div>
					}
				</div>
			</div>
			<div class="calendar-grid-col col-start-3 row-start-1 min-h-0 min-w-[120px] overflow-y-hidden">
				<div class="row-start-1 flex h-[56px] shrink-0 items-center justify-center">
					<button
						[matMenuTriggerFor]="calendarOptions"
						mat-icon-button
						tabindex="-1"
					>
						<mat-icon>settings</mat-icon>
					</button>
				</div>
				@for (day of vm.days; track day.dayKey; let i = $index) {
				<div
					[style.grid-row]="i + 2"
					class="min-h-0 overflow-hidden"
				>
					<app-calendar-day-summary
						[day]="day"
						[enabledTimes]="vm.enabledTimes"
					/>
				</div>
				}
			</div>
		</div>
	</div>
</div>

<tg-day-picker-popover
	(viewDateChange)="range.update($event)"
	[max]="maxRangeStart"
	[min]="minRangeStart"
	[viewDate]="range.value$ | async"
	#dayPickerPopover
	rangeType="week"
></tg-day-picker-popover>

<ng-template #toolbar>
	<div class="flex flex-col items-center 2xl:flex-row 2xl:items-start 2xl:flex-auto bg-ligth-gray">
		<div
			*ngIf="viewDate$status | async as vd"
			class="flex space-x-1"
		>
			<button
				(click)="prev()"
				[disabled]="(!vd.isFuture && !vd.isValidRange)"
				[matTooltip]="'utils.older' | translate"
				class="mat-button-square !rounded-lg"
				fxHide.lt-sm
				mat-button
			>
				<mat-icon>chevron_left</mat-icon>
			</button>
			<button
				(click)="dayPickerPopover.toggle()"
				[matTooltip]="'utils.pickTimeRange' | translate"
				[satPopoverAnchor]="dayPickerPopover"
				class="mt-1 h-10 flex items-center justify-start gap-1 !px-0"
				mat-button
			>
				<span>({{ 'timer.calendar.kw' | translate: { value: vd.start | formatDate: 'I' } }})</span>
			</button>
			<button
				(click)="next()"
				[disabled]="(vd.isFuture && !vd.isValidRange)"
				[matTooltip]="'utils.newer' | translate"
				class="mat-button-square !rounded-lg"
				fxHide.lt-sm
				mat-button
			>
				<mat-icon>chevron_right</mat-icon>
			</button>
			<button
				(click)="today()"
				[disabled]="vd.sameWeek"
				[matTooltip]="'timer.calendar.today' | translate"
				fxHide.lt-sm
				mat-icon-button
			>
				<mat-icon>today</mat-icon>
			</button>
		</div>
		<div>
			<button
				(click)="zoomOut()"
				[disabled]="hoursSegmentPreserts.value <= 2"
				[matTooltip]="'timer.calendar.zoomOut' | translate"
				mat-icon-button
			>
				<mat-icon>zoom_out</mat-icon>
			</button>
			<button
				(click)="zoomIn()"
				[disabled]="hoursSegmentPreserts.value >= 12"
				[matTooltip]="'timer.calendar.zoomIn' | translate"
				mat-icon-button
			>
				<mat-icon>zoom_in</mat-icon>
			</button>
		</div>
	</div>
</ng-template>

<mat-menu #calendarOptions="matMenu">
	<ng-template matMenuContent>
		<mat-card
			(click)="$event.stopPropagation()"
			class="mat-elevation-z0 flex flex-col gap-1"
		>
			<mat-checkbox
				(change)="startFromWorkDay.update($event.checked); startFromSchedule.update(false); onViewBoundsToggleChange()"
				[checked]="startFromWorkDay.value"
				color="primary"
			>
				{{ 'timer.calendar.showWorkHours' | translate }}
			</mat-checkbox>
			<mat-checkbox
				(change)="startFromSchedule.update($event.checked); startFromWorkDay.update(false); onViewBoundsToggleChange()"
				[checked]="startFromSchedule.value"
				color="primary"
			>
				{{ 'timer.calendar.startFromSchedule' | translate }}
			</mat-checkbox>
			<div class="flex flex-row gap-2">
				@for (weekDay of weekDaysForMenu; track weekDay.index) {
				<div class="flex flex-col items-center justify-between">
					<span>{{ weekDay.date | dfnsFormat: 'EEE' }}</span>
					<mat-checkbox
						(change)="onWeekDayVisibilityChange(weekDay.index, $event.checked)"
						[checked]="activeDaysOfWeek.value[weekDay.index]"
						color="primary"
					></mat-checkbox>
				</div>
				}
			</div>
		</mat-card>
	</ng-template>
</mat-menu>

<ng-template #blockEdit>
	<div class="flex flex-col space-y-2">
		<div>{{ 'time.blockEdit' | translate }}</div>
	</div>
</ng-template>
